export const qrCodeColumns = ['Código', 'Status', 'Data de criação', ''];
